import React, { useEffect, useRef } from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { trackViewContent } from '../../utils/metaPixel';
export function OfferSection() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        trackViewContent('Protocolo Maestro - Oferta');
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} id="oferta" className="py-24 relative overflow-hidden bg-brand-dark" data-id="element-174">
      {/* Simulated background image overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.1)_0%,rgba(10,10,10,1)_100%)]" data-id="element-175"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl" data-id="element-176">
        <div className="text-center mb-12" data-id="element-177">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4 glow-text" data-id="element-178">
            Desbloquea tu Acceso Inmediato
          </h2>
          <p className="text-brand-gold text-lg tracking-wide uppercase font-semibold" data-id="element-179">
            Oferta de Lanzamiento Limitada
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-0 rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(212,175,55,0.15)] border border-brand-gold/20" data-id="element-180">
          {/* Left Card: What's included */}
          <div className="md:w-1/2 bg-brand-card/95 p-8 md:p-10 backdrop-blur-sm" data-id="element-181">
            <h3 className="font-heading text-2xl font-bold text-white mb-6 border-b border-white/10 pb-4" data-id="element-182">
              Tu Arsenal Completo Incluye:
            </h3>

            <ul className="space-y-5" data-id="element-183">
              <li className="flex items-start" data-id="element-184">
                <div className="min-w-[24px] mt-1" data-id="element-185">
                  <BookOpenIcon className="w-4 h-4 text-brand-gold" data-id="element-186" />
                </div>
                <div data-id="element-187">
                  <span className="text-white font-medium block" data-id="element-188">
                    Libro Principal: Protocolo Maestro
                  </span>
                  <span className="text-gray-400 text-sm" data-id="element-189">
                    El sistema paso a paso (Valor USD47)
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-190">
                <div className="min-w-[24px] mt-1" data-id="element-191">
                  <GiftIcon className="w-4 h-4 text-brand-gold" data-id="element-192" />
                </div>
                <div data-id="element-193">
                  <span className="text-white font-medium block" data-id="element-194">
                    Bono #1: Bebidas Detox
                  </span>
                  <span className="text-gray-400 text-sm" data-id="element-195">
                    Sanando desde el interior (Valor USD27)
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-196">
                <div className="min-w-[24px] mt-1" data-id="element-197">
                  <GiftIcon className="w-4 h-4 text-brand-gold" data-id="element-198" />
                </div>
                <div data-id="element-199">
                  <span className="text-white font-medium block" data-id="element-200">
                    Bono #2: Protocolo Anti-Canas
                  </span>
                  <span className="text-gray-400 text-sm" data-id="element-201">
                    Pigmentación natural (Valor USD27)
                  </span>
                </div>
              </li>
            </ul>

            <div className="mt-8 pt-6 border-t border-white/10" data-id="element-202">
              <div className="flex justify-between items-center text-gray-400" data-id="element-203">
                <span data-id="element-204">Valor Total Real:</span>
                <span className="line-through text-lg font-bold text-red-400/80" data-id="element-205">
                  USD101.00
                </span>
              </div>
            </div>
          </div>

          {/* Right Card: Investment */}
          <div className="md:w-1/2 bg-gradient-to-br from-brand-dark to-[#1a160d] p-8 md:p-10 relative flex flex-col justify-center items-center text-center border-l border-brand-gold/10" data-id="element-206">
            <div className="absolute top-0 right-0 bg-red-600 text-white font-bold text-sm px-4 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-207">
              90% OFF HOY
            </div>

            <img src="https://i.postimg.cc/7YrWyfWR/portada-Mega-Pack-Terminada.webp" alt="Mega Pack" className="w-full max-w-sm mb-6 drop-shadow-2xl hover:scale-105 transition duration-500" data-id="element-208" />

            <p className="text-gray-300 mb-2 font-medium" data-id="element-209">
              Llevate todo el Megapack hoy por solo:
            </p>

            <div className="flex items-start justify-center mb-8 relative" data-id="element-210">
              <div className="absolute -inset-4 bg-brand-gold/10 blur-2xl rounded-full animate-pulse" data-id="element-211"></div>
              <span className="relative text-brand-gold text-4xl font-bold mt-3 mr-1" data-id="element-212">
                USD
              </span>
              <span className="relative text-transparent text-8xl md:text-9xl font-heading font-black leading-none bg-gradient-to-b from-brand-gold via-yellow-300 to-brand-gold bg-clip-text drop-shadow-[0_0_40px_rgba(212,175,55,0.5)]" data-id="element-213">
                12
              </span>
            </div>

            <div className="mt-4 flex flex-col items-center gap-2" data-id="element-214">
              <img src="https://i.postimg.cc/gjWq162N/selo-garantia-png-2.webp" alt="Garantía" className="h-10 opacity-80" data-id="element-215" />
              <p className="text-xs text-gray-500" data-id="element-216">
                Acceso inmediato y de por vida. Pago 100% seguro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}